import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AccountService } from "./account.service";

@Injectable()
export class PendingRegistrationGuard {
  constructor(private router: Router, private accountSvc: AccountService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let result = true;

    result = this.isAccountPendingConfiguration(state);
    if (!result) {
      this.router.navigate(["/"]);
      return result;
    }

    return result;
  }

  isAccountPendingConfiguration(state: RouterStateSnapshot) {
    const user = this.accountSvc.user;
    const result = user?.doneQuickSetup && !user?.configured;

    return !!result;
  }
}
